import React, { Component } from "react";
import Nav from "../Components/Nav";
// import DeskTop from "../Components/DeskTop";
import CarouselProduct from "../Components/CarouselProduct";
import Products from "../Components/Products";
import Footer from "../Components/Footer";
import { withTranslation } from "react-i18next";

import "./index.less";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (this.desktop && this.topContainer) {
      document.addEventListener("scroll", () => {
        if (
          document.documentElement.scrollTop >= this.topContainer.clientHeight
        ) {
          this.desktop.classList.add(["activeDeskTop"]);
        } else {
          this.desktop.classList.remove("activeDeskTop");
        }
      });
    }
  }

  render() {
    const { t } = this.props;
    return (
      <div className="home">
        <div ref={(ele) => (this.topContainer = ele)}>
          <Nav />
        </div>
        <CarouselProduct />
        {/*<DeskTop ref={(ele) => (this.desktop = ele)} />*/}
        <Products />
        <Footer />
      </div>
    );
  }
}

export default withTranslation()(Home);
